<div class="html-content {{ appearance() }}" *ngIf="content()" [innerHTML]="content() | tiSafeHtml"></div>
